import api from '../../utils/services/api';

import {
  transactionsActionError,
  transactionsActionLoading,
  transactionsActionSuccess,
} from '../ducks/transactions';

export const transactionsFetchAction = () => {
  return async (dispatch) => {
    dispatch(transactionsActionLoading());
    try {
      const response = await api.get(`/analise/range-data`);
      dispatch(transactionsActionSuccess(response.data));
    } catch (error) {
      dispatch(transactionsActionError(error?.response?.data));
    }
  };
};
